import { PermissionsData } from 'modules/authenticate/interfaces';

export const getHeaders = (permissions: PermissionsData | undefined) =>
  [
    {
      key: '',
      i18n: 'ACCESS_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'partner_name',
      i18n: 'PARTNER_NAME_KEY',
    },
    {
      order: true,
      key: 'company_name',
      i18n: 'OPERATOR_VIEW_COMPANY_NAME_KEY',
    },
    {
      order: true,
      key: 'partner_alias',
      i18n: 'ALIAS_KEY',
    },
    {
      order: true,
      key: 'partner_new_front_enabled',
      i18n: 'PARTNER_PAGE.OPERATOR_VIEW_NEW_FRONT_KEY',
      centerTitle: true,
      textAlignCenter: true,
    },
    {
      order: true,
      key: 'num_environments',
      i18n: 'ENVIRONMENTS_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'num_clients',
      i18n: 'CLIENTS_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'num_users',
      i18n: 'USERS_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'user_last_access',
      i18n: 'LAST_ACCESS_SINGULAR_KEY',
      centerTitle: true,
      textAlignCenter: true,
    },
    {
      key: '',
      i18n: 'ACTIONS_KEY',
      centerTitle: true,
      hidden:
        !!permissions &&
        !permissions.edit_partner_details &&
        !permissions.edit_user_theme_config,
    },
  ].filter(item => !item.hidden);
